import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { PageLoading } from "@/components/ui/loading";
import { LanguageProvider } from "@/contexts/LanguageContext";
import ScrollToTop from "@/components/ScrollToTop";

import Index from "./pages/Index";

const NotFound = lazy(() => import("./pages/NotFound"));
const Aluminum = lazy(() => import("./pages/Aluminum"));
const AluminumProductDetail = lazy(() => import("./pages/AluminumProductDetail"));
const Iron = lazy(() => import("./pages/Iron"));
const IronProductDetail = lazy(() => import("./pages/IronProductDetail"));
const Wood = lazy(() => import("./pages/Wood"));
const WoodProductDetail = lazy(() => import("./pages/WoodProductDetail"));
const KitchenCabinets = lazy(() => import("./pages/KitchenCabinets"));
const StainlessSteel = lazy(() => import("./pages/StainlessSteel"));
const StainlessSteelProductDetail = lazy(() => import("./pages/StainlessSteelProductDetail"));
const Glass = lazy(() => import("./pages/Glass"));
const GlassProductDetail = lazy(() => import("./pages/GlassProductDetail"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const Marble = lazy(() => import("./pages/Marble"));
const MarbleProductDetail = lazy(() => import("./pages/MarbleProductDetail"));
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const ArticlesPage = lazy(() => import("./pages/ArticlesPage"));
const ArticleDetail = lazy(() => import("./pages/ArticleDetail"));
const AdminAuth = lazy(() => import("./pages/AdminAuth"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<PageLoading />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/aluminum" element={<Aluminum />} />
                <Route path="/aluminum/:slug" element={<AluminumProductDetail />} />
                <Route path="/iron" element={<Iron />} />
                <Route path="/iron/:slug" element={<IronProductDetail />} />
                <Route path="/wood" element={<Wood />} />
                <Route path="/wood/:slug" element={<WoodProductDetail />} />
                <Route path="/kitchen-cabinets" element={<KitchenCabinets />} />
                <Route path="/stainless-steel" element={<StainlessSteel />} />
                <Route path="/stainless-steel/:slug" element={<StainlessSteelProductDetail />} />
                <Route path="/glass" element={<Glass />} />
                <Route path="/glass/:slug" element={<GlassProductDetail />} />
                <Route path="/marble" element={<Marble />} />
                <Route path="/marble/:slug" element={<MarbleProductDetail />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/articles" element={<ArticlesPage />} />
                <Route path="/articles/:id" element={<ArticleDetail />} />
                <Route path="/admin/auth" element={<AdminAuth />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
};

export default App;
